import { NavLink } from "react-router-dom";
import Breadcumbs from "../../components/Breadcumbs";
import DataFetcherTemplate from "../../hooks/fetchTemplate";
import BannerGeneral from "../../components/BannerGeneral";
import BlockImageCabecera from "../../components/BlockImageCabecera";
import Quote from "../../components/Quote";
import calendario from "../../img/iconsoferta/calendario.png";
import modalidad from "../../img/iconsoferta/modalidad.png";
import titulo from "../../img/iconsoferta/titulo.png";
import sale from "../../img/iconsoferta/sale.png";
import inicio from "../../img/iconsoferta/inicio.png";
import { DistanciaNuevosFixed } from "../../components/Pasos";
import Block5Columns from "../../components/Block5Columns";
import BlockBackgroundImage from "../../components/BlockBackgroundImage";
import BlockRightImage from "../../components/BlockRightImage";
import AccordionFromHtml from "../../components/Accordionfromhtml";
import TecPagos from "../../components/TecPagos";
import BlockLeftImage from "../../components/BlockLeftImage";
import Gallery from "../../components/Gallery";
import Modal from "../../components/Modal";

import Notification from "../../components/Notification";
const url = "https://tec.utpl.edu.ec";
function TecComunicacionEstrategica() {
  const datagallery = [
    {
      title: "utpl",
      url: "https://www.utpl.edu.ec/carreras/sites/default/files/1_11.png",
    },
    {
      title: "utpl",
      url: "https://www.utpl.edu.ec/carreras/sites/default/files/2_9.png",
    },
    {
      title: "utpl",
      url: "https://www.utpl.edu.ec/carreras/sites/default/files/3_5.png",
    },
    {
      title: "utpl",
      url: "https://www.utpl.edu.ec/carreras/sites/default/files/4_6.png",
    },
  ];

  const competencia1 = [
    {
      id: 1,
      titulo: "Desarrollar productos comunicacionales multimedia",
      asignaturas: [
        {
          nombre: "Herramientas en tecnología móvil",
          evidencias: [
            {
              tipo: "Certificado / Taller",
              items: [
                "Certificado de marketing móvil o mobile Apps.",
                "Certificado/Taller de diseño de apps móviles.",
                "Certificado de User Experience o Design Thinking.",
                "Taller práctico de WhatsApp Business, SMS marketing y uso de Apps de mensajería.",
              ],
            },
          ],
        },
        {
          nombre: "Diseño gráfico y fotografía digital",
          evidencias: [
            {
              tipo: "Certificado / Portafolio",
              items: [
                "Portafolio con piezas gráficas y fotografías conceptuales",
                "Certificado de experiencia de clientes o empresa",
              ],
            },
          ],
        },

        {
          nombre: "Prácticum 1",
          evidencias: [
            {
              tipo: "Informe profesional",
              items: [
                "Reconocimiento del Prácticum 1, 2 y 3 a través de experiencia laboral",
              ],
            },
          ],
        },

        {
          nombre: "Negocios Digitales",
          evidencias: [
            {
              tipo: "Certificado / Taller / Portafolio",
              items: [
                "Certificado en fundamentos de negocios digitales",
                "Taller de tecnologías SMAC (Social, Mobility, Analytics, Cloud)",
                " Portafolio de análisis de caso de negocio digital",
              ],
            },
          ],
        },

        {
          nombre: "Metodología de la investigación y técnicas de estudio",
          evidencias: [
            {
              tipo: "Certificado / Informe académico",
              items: [
                "Certificado de curso de investigación científica. ",
                "Ensayo o artículo académico publicado",
                " Informe de búsqueda sistemática en bases de datos",
              ],
            },
          ],
        },

        {
          nombre: "Producción y edición de audiovisual para entornos digitales",
          evidencias: [
            {
              tipo: "Certificado / Portafolio",
              items: [
                "Certificado de software de edición (Premiere, Final Cut)",
                " Muestra de productos audiovisuales para web (portafolio)",
                "Certificados de trabajo en áreas afines a la producción audiovisual (productoras o medios audiovisuales legalmente constituidos)",
              ],
            },
          ],
        },
      ],
    },
  ];
  const competencia2 = [
    {
      id: 2,
      titulo: "Diagnosticar la gestión de la comunicación y marketing digital",
      asignaturas: [
        {
          nombre: "Marketing digital",
          resultado_aprendizaje:
            "Implementa la estrategia de marketing digital en la empresa a partir de las acciones identificadas, para fortalecer su posicionamiento digital.",
          evidencias: [
            {
              tipo: "Certificado / Taller",
              items: [
                "Certificación Google Ads o SEM.",
                "Taller de SEO.",
                "Evidencias de campañas de email marketing o embudos de conversión.",
              ],
            },
          ],
        },
        {
          nombre: "Contenidos multimedia y trasmedia",
          resultado_aprendizaje:
            "Determina la estrategia de contenido multimedia y transmedia, en función de la estrategia global de comunicación.",
          evidencias: [
            {
              tipo: "Certificado / Portafolio",
              items: [
                "Certificado en narrativas transmedia.",
                "Muestras de contenidos hipermedia y crossmedia (portafolio).",
              ],
            },
          ],
        },
        {
          nombre: "Estrategias de comunicación en redes sociales",
          resultado_aprendizaje:
            "Identifica proyectos digitales e interactivos, cuyos contenidos puedan ser adaptados a distintos contextos culturales, para ser distribuidos a través de diferentes canales y plataformas.",
          evidencias: [
            {
              tipo: "Certificado / Portafolio",
              items: [
                "Certificado de Social Media Marketing.",
                "Plan de contenidos y métricas de una campaña real (portafolio).",
              ],
            },
          ],
        },
        {
          nombre: "Prácticum 2",
          resultado_aprendizaje:
            "Establece técnicas de investigación para el levantamiento de información que contribuya al diagnóstico comunicacional del escenario real.",
          evidencias: [
            {
              tipo: "Informe profesional",
              items: [
                "Reconocimiento del Prácticum 1, 2 y 3 a través de experiencia laboral.",
              ],
            },
          ],
        },
      ],
    },
  ];

  const competencia3 = [
    {
      id: 3,
      titulo:
        "Emplear estrategias y herramientas de marketing digital actuales",
      asignaturas: [
        {
          nombre: "Interoperabilidad empresarial",
          resultado_aprendizaje:
            "Integra diferentes productos o sistemas computarizados para conectarse e intercambiar fácilmente información entre sí, ya sea en la implementación o el acceso, sin restricciones.",
          evidencias: [
            {
              tipo: "Certificado / Portafolio",
              items: [
                "Certificados de formación técnica relacionada con el uso de APIS.",
                "Evidencia de proyectos reales o laborales con integración de sistemas.",
                "Demo funcional de una integración realizada.",
                "Informes o propuestas estratégicas donde se planifica interoperabilidad (CRM + redes sociales + analítica).",
                "Estrategia digital donde se detallan flujos de automatización e interoperabilidad.",
                "Experiencia comprobable en herramientas específicas como Zapier, Make, Integromat, n8n, Power Automate, etc.",
              ],
            },
          ],
        },
        {
          nombre: "Desarrollo web",
          resultado_aprendizaje:
            "Relaciona estratégicamente las herramientas web, que permitan mejorar la usabilidad y experiencia del usuario.",
          evidencias: [
            {
              tipo: "Certificado / Portafolio",
              items: [
                "Certificación en desarrollo front-end (HTML/CSS/JS).",
                "Enlace a landing page o proyecto web desarrollado.",
              ],
            },
          ],
        },
        {
          nombre: "Herramientas de medición y Control",
          resultado_aprendizaje:
            "Aplica diferentes técnicas de análisis de medición y evaluación, para ejecutar campañas de marketing digital.",
          evidencias: [
            {
              tipo: "Certificado / Portafolio",
              items: [
                "Certificado de Google Analytics (GA4).",
                "Certificación en analítica social (Meta, Hootsuite o Sprout Social).",
                "Certificación de Google Data Studio / Looker Studio.",
                "Certificación SEMrush o Ahrefs (SEO).",
                "Dashboard de monitoreo con métricas clave interpretadas.",
                "Informe de auditoría SEO + redes sociales con hallazgos y propuesta de mejora.",
                "Análisis completo del diagnóstico de una marca (auditorías).",
                "Bitácora o portafolio de uso de herramientas de analítica web y social.",
                "Informe de participación en proyectos reales firmado por el tutor profesional.",
              ],
            },
          ],
        },
        {
          nombre: "Social media marketing",
          resultado_aprendizaje:
            "Relaciona los elementos y herramientas del social media, para la implementación de la estrategia de marketing digital de la empresa.",
          evidencias: [
            {
              tipo: "Certificado / Caso de estudio",
              items: [
                "Certificado en Social Media Ads.",
                "Estudio de caso de campaña de influencers o análisis de tendencias.",
                "Elaboración de Social Media Plan.",
                "Elaboración de productos audiovisuales para redes sociales.",
              ],
            },
          ],
        },
        {
          nombre: "Prácticum 3",
          resultado_aprendizaje:
            "Desarrolla proyectos comunicacionales digitales de servicio comunitario.",
          evidencias: [
            {
              tipo: "Informe profesional / Certificado de servicio comunitario",
              items: [
                "Reconocimiento del Prácticum 1, 2 y 3 a través de experiencia laboral.",
              ],
            },
          ],
        },
      ],
    },
  ];

  const competencia4 = [
    {
      id: 4,
      titulo:
        "Planificar y desarrollar estrategias de marketing y comunicación digital",
      asignaturas: [
        {
          nombre: "Estrategias y plataformas de ecommerce",
          resultado_aprendizaje:
            "Aplica acciones para generar estrategias de comercio electrónico en las organizaciones.",
          evidencias: [
            {
              tipo: "Certificado / Portafolio",
              items: [
                "Certificación en e-commerce fundamentales.",
                "Análisis comparativo de plataformas (Shopify, WooCommerce) con recomendaciones.",
                "Desarrollo de software.",
              ],
            },
          ],
        },
        {
          nombre: "Gestión de relaciones y comportamiento del consumidor",
          resultado_aprendizaje:
            "Distingue las nuevas tendencias de consumo y las necesidades del consumidor, a través de herramientas y plataformas digitales, para la generación de nuevas propuestas de fidelización para el cliente.",
          evidencias: [
            {
              tipo: "Certificado / Caso de CRM",
              items: [
                "Certificado en CRM (Salesforce, HubSpot).",
                "Caso de fidelización con métricas de inbound/permissive marketing (informe).",
              ],
            },
          ],
        },
        {
          nombre: "Emprendimiento digital",
          resultado_aprendizaje:
            "Crea y evalúa oportunidades de negocio para ecosistema digital.",
          evidencias: [
            {
              tipo: "Certificado / Plan de negocio",
              items: [
                "Certificado de incubadora o aceleradora digital.",
                "Plan de negocio digital con prototipo y lanzamiento (documento).",
              ],
            },
          ],
        },
        {
          nombre: "Publicidad digital",
          resultado_aprendizaje:
            "Organiza e implementa la estrategia creativa para el desarrollo de campañas digitales específicas y efectivas.",
          evidencias: [
            {
              tipo: "Certificado / Portafolio",
              items: [
                "Portafolio de campañas digitales (estrategia creativa).",
                "Certificados de formación.",
                "Talleres o cursos en marketing digital, planificación y elaboración de campañas: Meta Ads, Google Ads, etc.",
              ],
            },
          ],
        },
        {
          nombre: "Comunicación estratégica digital",
          resultado_aprendizaje:
            "Interpreta el diagnóstico de la organización, para definir la estrategia de comunicación digital.",
          evidencias: [
            {
              tipo: "Certificado / Portafolio",
              items: [
                "Certificado en estrategia digital 360°.",
                "Diagnóstico y plan estratégico de comunicación para una organización real (documento).",
              ],
            },
          ],
        },
      ],
    },
  ];
  const DataDisplay = ({ data }) => (
    <>
      <div>
        {data.map((item, index) => (
          <div>
            <div className="relative">
              <BlockImageCabecera
                src={url + item.field_imagen_template}
                title={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_texto_portada,
                      }}
                    />
                  </>
                }
              ></BlockImageCabecera>
              <DistanciaNuevosFixed></DistanciaNuevosFixed>
            </div>
            <div className="lightbluebg">
              <Breadcumbs
                content={
                  <>
                    <NavLink to="/tecnologias">Tecnologías</NavLink>
                    <span class="material-icons">chevron_right</span>
                    <NavLink to="/tecnologia-comunicacion">
                      Tecnología Superior en Comunicación Estratégica y
                      Marketing Digital
                    </NavLink>
                  </>
                }
              ></Breadcumbs>
              <div className="padding oferta-icons">
                <p
                  className="layout8"
                  dangerouslySetInnerHTML={{
                    __html: item.field_carrera_resolucion,
                  }}
                />

                <Block5Columns
                  col1={
                    <>
                      <img src={titulo}></img>
                      <p>
                        <b>Título</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_titulo,
                        }}
                      />
                    </>
                  }
                  col2={
                    <>
                      <img src={modalidad}></img>
                      <p>
                        <b>Modalidad</b>
                      </p>{" "}
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_modalidad,
                        }}
                      />{" "}
                    </>
                  }
                  col3={
                    <>
                      <img src={calendario}></img>
                      <p>
                        <b>Duración</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_duracion,
                        }}
                      />
                    </>
                  }
                  col4={
                    <>
                      <img src={sale}></img>

                      <p>
                        <b>Inversión</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_costo,
                        }}
                      />
                      <a
                        className="link-with-arrow fontsize10pt"
                        href="#descuentos"
                      >
                        Accede a becas y descuentos
                      </a>
                    </>
                  }
                  col5={
                    <>
                      <img src={inicio}></img>
                      <p>
                        <b>Fecha de inicio</b>
                      </p>{" "}
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.field_fecha_inicio,
                        }}
                      />
                    </>
                  }
                ></Block5Columns>
              </div>
            </div>
            <a href="https://utpl.edu.ec/validacion-tecnologias">
              {" "}
              <img src="https://www.utpl.edu.ec/carreras/sites/default/files/banner-rec.png"></img>{" "}
            </a>

            {/* <div className="margin">
              <Block3Columns
                col1={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_descripcion_tec,
                      }}
                    />{" "}
                  </>
                }
                col2={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_descripcion1,
                      }}
                    />{" "}
                  </>
                }
                col3={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_descripcion2,
                      }}
                    />
                  </>
                }
              ></Block3Columns>
            </div> */}
            {item.field_atributo1 && item.field_atributo1.trim() !== "" && (
              <Quote
                content={
                  <p
                    dangerouslySetInnerHTML={{
                      __html: item.field_atributo1,
                    }}
                  />
                }
              />
            )}

            <div id="perfil">
              <BlockBackgroundImage
                src={url + item.field_imagen_perfil_profesional}
                content={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_perfil_profesional,
                    }}
                  />
                }
              ></BlockBackgroundImage>
            </div>
            <div className="lightbluebg">
              <BlockRightImage
                src={url + item.field_imagen_campo_ocupacional}
                content={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_campo_ocupacional,
                      }}
                    />
                  </>
                }
              ></BlockRightImage>
            </div>
            <div className="layout8 padding" id="malla">
              <div
                className="width700"
                dangerouslySetInnerHTML={{
                  __html: item.field_malla_titulo,
                }}
              />
              <div className="layout6">
                <AccordionFromHtml htmlContent={item.field_malla}>
                  {" "}
                </AccordionFromHtml>
              </div>
            </div>

            <div className="padding" id="descuentos">
              <TecPagos></TecPagos>
            </div>
            {item.field_atributo2 && item.field_atributo2.trim() !== "" && (
              <Quote
                content={
                  <p
                    dangerouslySetInnerHTML={{
                      __html: item.field_atributo2,
                    }}
                  />
                }
              />
            )}
            <div className="icon300 padding lightbluebg">
              <BlockRightImage
                src={url + item.field_imagen_docente}
                content={
                  <>
                    <p className="iconsize20">📣</p>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_texto_docente,
                      }}
                    />
                  </>
                }
              ></BlockRightImage>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <>
      <DataFetcherTemplate url="https://tec.utpl.edu.ec/tec-comunicacion">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>{" "}
      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default TecComunicacionEstrategica;
